export const baseUrl = "/api"
const resource = "/help"

export function sendOfferteAanvraag(data, image1, image2, image3, image4) {
    const formData = new FormData();
    if (image1 != null) {
        formData.append('image1', image1);
    }
    if (image2 != null) {
        formData.append('image2', image2);
    }
    if (image3 != null) {
        formData.append('image3', image3);
    }
    if (image4 != null) {
        formData.append('image4', image4);
    }
    formData.append('data', new Blob([JSON.stringify(data)], {
        type: "application/json"
    }));
    return fetch(`${baseUrl}${resource}/offerte-aanvraag`, {method: "POST", body: formData})
}